import { Service } from '@roc/client-portal-shared/services';

const url = {
  CDA_DOCUMENT: '/nportal/rest/pub/payments/getCDADocusign?entity=',
  GENERATE_CDA_DOCUMENT:
    '/nportal/rest/pub/signing/generateCDADisclosureDocument',
  ARR_CDA_DOCUMENT: '/nportal/rest/pub/payments/getARRDocusign?entity=',
  APPRAISAL_RECERTIFICATION_DOCUMENT:
    '/nportal/rest/pub/payments/getAppraisalRecertificationDocusign?entity=',
  GENERATE_FAST_TRACK: '/nportal/rest/pub/signing/generateFastTrackDocument',
  FETCH_AMC_PAYMENT_LINK: '/api/v1/loan/internalValuation/getAmcPaymentLink',
};

export class LoanTermsService extends Service {
  getArrDocusign(request) {
    return this.post(`${url.ARR_CDA_DOCUMENT}`, request, undefined, {
      responseType: 'text',
    });
  }

  getAppraisalRecertificationDocusign(request) {
    return this.post(
      `${url.APPRAISAL_RECERTIFICATION_DOCUMENT}`,
      request,
      undefined,
      {
        responseType: 'text',
      }
    );
  }

  getCDADocusign(request) {
    return this.post(`${url.CDA_DOCUMENT}`, request, undefined, {
      responseType: 'text',
    });
  }

  generateCDADisclosureDocument(request) {
    return this.post(`${url.GENERATE_CDA_DOCUMENT}`, request);
  }

  getAmcPayment = (loanId: any) => {
    return this.get(`${url.FETCH_AMC_PAYMENT_LINK}?loanId=${loanId}`);
  };
}
